/**
 * Set of system app addon keys.
 * These are special built-in applications that are part of the system.
 */
const SYSTEM_APP_ADDON_KEYS = new Set([
	'jira-slack-integration', // Start Jira entries from MICROS_ENVTYPE/prod.yaml
	'com.atlassian.servicedesk.embedded',
	'com.atlassian.servicedesk.embedded.moderate',
	'stspg-jira-ops',
	'com.atlassian.jira.spreadsheets',
	'atlassian-outlook-integration',
	'com.codebarrel.addons.automation',
	'com.codebarrel.addons.automation.moderate',
	'opsgenie-jira-adapter',
	'opsgenie-jira-adapter.moderate',
	'halp.com',
	'halp.moderate.com',
	'msteams-jira',
	'com.atlassian.atlas.jira',
	'cello', // Start Confluence entries from confluence.sd.yml
	'msteams-confluence',
	'opsgenie-incident-timeline-lab',
	'com.addonengine.analytics', // Confluence IC additional entry from ic_confluence.sd.yml
]);

/**
 * Determines if an app is a system app based on its addon_key.
 * System apps are special built-in applications that are part of the system infrastructure.
 *
 * @param {string} addonKey - The addon_key of the AppInstance to check
 * @returns {boolean} true if the app is a system app, false otherwise
 */
export function isSystemApp(addonKey: string): boolean {
	return SYSTEM_APP_ADDON_KEYS.has(addonKey);
}
